import {CommonBuildConfigurationInput as BuildConfigurationInput} from '../commonConfiguration.types'

import {LoadSpacingConfiguration} from './types'

export const buildLoadSpacingConfiguration = ({
  options,
  inputProps
}: BuildConfigurationInput): LoadSpacingConfiguration => {
  if (!options.constraints.loadSpacing.isEnabled) {
    return {loadSpacing: {isEnabled: false}}
  }

  return {
    loadSpacing: {
      ...options.constraints.loadSpacing,
      enableAutoAdjustment: inputProps.enableLoadSpacingAutoAdjustment
    }
  }
}
